import { GetGeneratableDocumentsTemplateAssignedProjectRes } from '@dealstack/shared/lib/generated';
import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { createDateColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/DateColumn';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { Button, Flex } from '@mantine/core';

const createLinkedProjectsActionColumn = (
	setSelectedDealId: (dealId: string) => void,
	onUnassignProject: (dealId: string) => void
): ExtendedColumnDef<GetGeneratableDocumentsTemplateAssignedProjectRes> => {
	return {
		cell: ({ row }) => {
			return (
				<Flex gap="1rem" align="center">
					<Button
						variant="primary"
						onClick={() => {
							setSelectedDealId(row.original.dealId);
						}}
					>
						Details
					</Button>
					<Button
						variant="deletion"
						onClick={() => {
							onUnassignProject(row.original.dealId);
						}}
					>
						Unlink
					</Button>
				</Flex>
			);
		},
		header: '',
		id: 'actions',
		enableGlobalFilter: false,
		enableColumnFilter: false,
		filter: () => <div />,
		size: 200,
		meta: {
			isGrow: true,
		},
	};
};

export const createLinkedProjectsTableColumns = (
	setSelectedDealId: (dealId: string) => void,
	onUnassignProject: (dealId: string) => void
): ExtendedColumnDef<GetGeneratableDocumentsTemplateAssignedProjectRes>[] => [
	createTextColumn({ headerText: 'Project name', accessorKey: 'projectName' }),
	createDateColumn({
		id: 'updatedAt',
		headerText: 'Linked to project at',
		accessorFn: ({ updatedAt }) => !!updatedAt && new Date(updatedAt),
		sortingFn: 'datetime',
	}),
	createLinkedProjectsActionColumn(setSelectedDealId, onUnassignProject),
];
